import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { decamelize } from '../../utils/keysConverter';

export default {
  load(params) {
    const url = formUrl('/api/v1/admin/cashbacks');
    return FetchHelpers.get(url, decamelize(params));
  },

  create(params) {
    const url = formUrl('/api/v1/admin/cashbacks');

    return FetchHelpers.post(url, decamelize(params));
  },

  delete(id) {
    const url = formUrl(`/api/v1/admin/cashbacks/${id}`);

    return FetchHelpers.delete(url);
  },
};
